import React from "react";

const Documentation = () => {
  return <div>Documentation</div>;
};

export default Documentation;
